import type { OriginalUserData } from '@/types/impersonation';
import { createContext, useContext } from 'react';

export interface AuthUser {
  id: string;
  email: string;
  name: string;
  picture: string;
  asesor?: {
    id: string;
    nombre: string;
    correo: string;
    telefono: string;
    cantEmpresas: number;
    rol: string;
    /** Correo guardado con "+" al inicio en la BD: ve la sección Revisión de hallazgos. */
    gestionIssues?: boolean;
  };
}

export const AuthContext = createContext<AuthContextType | null>(null);

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}

export function useOptionalAuth() {
  return useContext(AuthContext);
}
export interface AuthContextType {
  token: string | null;
  user: AuthUser | null;
  isAuthenticated: boolean;
  isValidating: boolean;
  login: (idToken: string) => Promise<void>;
  localLogin: (email: string) => Promise<void>;
  logout: () => void;
  // Impersonación
  isImpersonating: boolean;
  impersonatedBy: number | null;
  originalUser: OriginalUserData | null;
  impersonate: (asesorId: number) => Promise<void>;
  revertImpersonation: () => Promise<void>;
  switchToAdmin: () => Promise<void>;
}
